export default __webpack_public_path__ + "images/referrals-onboarding-step-1_2x.d1ba34c62820c593c1a90748b4e69bb0.png";